// extracted by mini-css-extract-plugin
export default {"container":"Page_container__7r3OG","header":"Page_header__GOE2x","headerTitle":"Page_headerTitle__bCvCI","body":"Page_body__U7jy9"};